import * as React from 'react';
import { Select, MenuItem, FormControl, Box } from '@mui/material';
import { ApartmentOutlined } from '@mui/icons-material';
import { serviceLocator } from '../services';

const authenticationService = serviceLocator.getAuthenticationService();
const agencyService = serviceLocator.getAgencyService();
const uiService = serviceLocator.getUIService();

interface State {
    agencies: (string[] | null);
}

let agenciesPromise: Promise<string[]> | null = null;

const selectSx = {
    minWidth: 184,
    height: 40,
    borderRadius: 999,
    color: 'rgba(244, 246, 255, 0.92)',
    backgroundColor: 'rgba(255, 255, 255, 0.06)',
    paddingLeft: 1,
    fontSize: 13,
    fontWeight: 500,
    letterSpacing: '-0.003em',
    transition: 'background-color 200ms ease, border-color 200ms ease',
    '& .MuiSelect-icon': {
        color: 'rgba(244, 246, 255, 0.6)',
        right: 10,
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255, 255, 255, 0.16)',
    },
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.10)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255, 255, 255, 0.32)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(250, 135, 28, 0.7)',
        borderWidth: 1.5,
    },
} as const;

export class AgencyPicker extends React.Component<any, State> {

    state: State = {
        agencies: null,
    };

    handleChange = (e: any) => {
        const value = e.target.value;
        uiService.setSelectedAgency(value === 'all' ? '' : value);
    };

    componentDidMount = async () => {
        if (this.state.agencies == null) {
            const authData = authenticationService.getAuthenticatedUserData();
            if (authData != null && authData.roles != null && authData.roles.indexOf('admin') !== -1) {
                if (agenciesPromise == null) {
                    agenciesPromise = agencyService.listAgencies(true).then(({ agencies }) => Promise.resolve(agencies.map(x => x.identifier)));
                }
                const agencies = await agenciesPromise;
                this.setState({ agencies });
            }
        }
    };

    render() {
        const authData = authenticationService.getAuthenticatedUserData();
        if (authData == null) return null;
        const admin = authData.roles.indexOf('admin') !== -1;
        const agenciesArr: string[] = this.state.agencies || authData.agencies || [];

        const agencies: Array<{ text: string; value: string }> = agenciesArr.map(x => ({ text: x, value: x }));
        const allLabel = admin ? 'All agencies' : 'Any agency';
        const agenciesExtended = [{ text: allLabel, value: 'all' }, ...agencies];

        let selectedAgency = uiService.getSelectedAgency() || 'all';
        if (agenciesArr.indexOf(selectedAgency) === -1) {
            selectedAgency = 'all';
        }

        return (
            <FormControl size="small">
                <Select
                    onChange={this.handleChange}
                    title="Selected agency"
                    id="selected-agency"
                    name="selected-agency"
                    value={selectedAgency}
                    variant="outlined"
                    sx={selectSx}
                    renderValue={(value) => {
                        const item = agenciesExtended.find(x => x.value === value) ?? agenciesExtended[0];
                        return (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                <ApartmentOutlined sx={{ fontSize: 16, color: 'rgba(255, 180, 92, 0.92)' }} />
                                <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.text}</Box>
                            </Box>
                        );
                    }}
                >
                    {agenciesExtended.map(x => (
                        <MenuItem key={x.value} value={x.value}>
                            {x.text}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    }
}
